export class CardFilter {
    filtering: string = null;
    sorting: string = null;
    dateTimeFrom: Date | string | null = null;
    dateTimeTo: Date | string | null = null;
    cardsToBeActivated = false
    cardsToBeDeactivated = false
    roomsToBeVacated = false
    roomsToBeRented = false
}
